import * as ast from 'notebook/tables/excess/AST';
import {
  Environment,
  MultiDocSpreadsheetEvaluator,
  SingleDocSpreadsheetEvaluator,
} from 'notebook/tables/excess/Evaluator';
import FormulaUtil from 'notebook/tables/excess/FormulaUtil';
import {functions} from 'notebook/tables/excess/functions';
import FillDown from 'notebook/tables/excess/ops/fillDown';
import paste from 'notebook/tables/excess/ops/paste';
import {
  deleteColumns,
  deleteRows,
  deleteRowsNonContiguous,
  insertColumnsLeft,
  insertColumnsRight,
  insertRowsAbove,
  insertRowsBelow,
  mergeRegion,
  renameTable,
  reorderRowsOrColumns,
  unmergeRegion,
  mergeIntoSingleInput,
  unmergeSingleInput,
  wrapTableOpForSingleDoc,
} from 'notebook/tables/excess/ops/TableOps';
import parser from 'notebook/tables/excess/Parser';
import tokenizer from 'notebook/tables/excess/Tokenizer';
import * as util from 'notebook/tables/excess/Util';

// Single source of truth for EXCESS_VERSION, shared with the Python monolith.
// When bumping EXCESS_VERSION, update excessVersion.json and describe the changes in EXCESS_CHANGELOG.md
const {version: EXCESS_VERSION_BASE} = require('./excessVersion.json');

// Lazily evaluated so tests can set window.REVISION and observe the change.
export function getExcessVersion(): string {
  let revision = 'unknown';
  if (typeof window !== 'undefined' && window.REVISION) {
    revision = window.REVISION;
  }
  return `${EXCESS_VERSION_BASE}+${revision}`;
}

const {fillDown} = FillDown;

export default {
  get EXCESS_VERSION() {
    return getExcessVersion();
  },
  Environment,
  SpreadsheetEvaluator: SingleDocSpreadsheetEvaluator,
  MultiDocSpreadsheetEvaluator,
  parser,
  parse: parser.parse,
  util,
  functions,
  tokenizer,
  ast,
  ops: {
    deleteColumns,
    deleteRows,
    deleteRowsNonContiguous,
    fillDown,
    insertColumnsLeft,
    insertColumnsRight,
    insertRowsAbove,
    insertRowsBelow,
    reorderRowsOrColumns,
    renameTable,
    mergeRegion,
    unmergeRegion,
    mergeIntoSingleInput,
    unmergeSingleInput,
    paste,
    wrapTableOpForSingleDoc,
  },
  FormulaUtil,
};
